import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-svg-bac',
    templateUrl: './svg-bac.component.html',
    styleUrls: ['./svg-bac.component.css'],
    standalone: false
})
export class SvgBacComponent implements OnInit {
  @Input() darkcolor;
  @Input() lightcolor;

  constructor() { }

  ngOnInit() {
  }

}
